{
  "super_admin": "ผู้ดูแลระบบสูงสุด",
  "ops_manager": "ผู้จัดการปฏิบัติการ",
  "operator": "ผู้ปฏิบัติงาน",
  "account_manager": "ผู้ดูแลบัญชี",
  "developer": "นักพัฒนา",
  "auditor": "ผู้ตรวจสอบ",
  "service_account": ""
}
